/**
 * VideoForm - Form for adding/editing the single featured video
 * Category field removed per user request
 */
import { Video, Save, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { ImageUpload } from '../ImageUpload';

export const VideoForm = ({
  videoFormData,
  setVideoFormData,
  editingVideo,
  onSubmit,
  onCancel,
  saving
}) => (
  <form onSubmit={onSubmit} className="bg-zinc-900 rounded-xl p-6 space-y-4 border border-white/10" data-testid="video-form">
    <h3 className="text-white font-bold flex items-center gap-2">
      <Video className="w-5 h-5 text-orange-500" />
      {editingVideo ? 'Edit Featured Video' : 'Set Featured Video'}
    </h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-zinc-400 text-sm mb-1">Video Title *</label>
        <input
          type="text"
          value={videoFormData.title}
          onChange={(e) => setVideoFormData({ ...videoFormData, title: e.target.value })}
          placeholder="e.g., Game Highlights: Team A vs Team B"
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          data-testid="video-title-input"
          required
        />
      </div>
      <div>
        <label className="block text-zinc-400 text-sm mb-1">YouTube URL *</label>
        <input
          type="url"
          value={videoFormData.youtube_url}
          onChange={(e) => setVideoFormData({ ...videoFormData, youtube_url: e.target.value })}
          placeholder="https://youtube.com/watch?v=..."
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          data-testid="video-url-input"
          required
        />
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-zinc-400 text-sm mb-1">Duration (e.g., 01:22)</label>
        <input
          type="text"
          value={videoFormData.duration}
          onChange={(e) => setVideoFormData({ ...videoFormData, duration: e.target.value })}
          placeholder="01:22"
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        />
      </div>
    </div>
    
    <ImageUpload
      value={videoFormData.thumbnail_url}
      onChange={(url) => setVideoFormData({ ...videoFormData, thumbnail_url: url })}
      label="Custom Thumbnail (optional)"
      placeholder="Leave blank to use YouTube thumbnail"
      previewSize="md"
    />

    <div>
      <label className="block text-zinc-400 text-sm mb-1">Description</label>
      <textarea
        value={videoFormData.description}
        onChange={(e) => setVideoFormData({ ...videoFormData, description: e.target.value })}
        placeholder="Brief description of the video..."
        rows={2}
        className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        data-testid="video-desc-input"
      />
    </div>

    <div className="flex gap-2 pt-2">
      <Button type="submit" disabled={saving} className="bg-orange-500 hover:bg-orange-600" data-testid="video-submit-btn">
        {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
        {editingVideo ? 'Update Video' : 'Save Featured Video'}
      </Button>
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  </form>
);

export default VideoForm;
